import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function EditIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.3798,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
  };
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <path
          style={st0}
          d="M16.63,21.1c0,0.38-0.31,0.7-0.7,0.7H1.42c-0.38,0-0.7-0.31-0.7-0.7V3.03c0-0.38,0.31-0.7,0.7-0.7h14.51
		c0.38,0,0.7,0.31,0.7,0.7C16.63,3.03,16.63,21.1,16.63,21.1z"
        />
      </g>
      <path
        d="M23.86,5.86C23.94,5.77,24,5.65,24,5.51c0-0.14-0.06-0.27-0.16-0.36l-2.8-2.8c-0.09-0.09-0.22-0.16-0.36-0.16
	c-0.15,0-0.29,0.07-0.38,0.18l-1.96,1.96l0,0l-8.81,8.81l0.06,0.06l-1.78,4.51c-0.1,0.08-0.17,0.2-0.17,0.34
	c0,0.25,0.2,0.45,0.45,0.45c0.12,0,0.24-0.05,0.32-0.13l0.01,0.01l4.6-1.75l0.02,0.02l8.81-8.81l-0.01-0.01L23.86,5.86L23.86,5.86z"
      />
    </SvgIcon>
  );
}
